import { shallowRef } from "@vue/reactivity";
import { useToast } from "primevue/usetoast";
import { useI18n } from "./shared/composables/use-i18n";

export class AppModel {
    toast = shallowRef<ReturnType<typeof useToast>>(
        undefined as unknown as ReturnType<typeof useToast>,
    );

    i18n = shallowRef<ReturnType<typeof useI18n>>(
        undefined as unknown as ReturnType<typeof useI18n>,
    );

    initialized = shallowRef(false);

    setup = (): void => {
        this.toast.value = useToast();
        this.i18n.value = useI18n() as unknown as ReturnType<typeof useI18n>;
        this.initialized.value = true;
    };
}

export const appModel = new AppModel();
